<template>
  <div class="group-input col-12 row q-mt-sm">
    <label for="os_number">Número da OS</label>
    <q-input
      id="os_number"
      ref="osNumberRef"
      v-model="requestData.osNumber"
      class="col-12 q-mt-sm"
      bg-color="white"
      maxlength="10"
      color="red-9"
      dense
      outlined
      mask="##########"
      unmasked-value
      placeholder="0000000000"
      :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
      lazy-rules
    />
  </div>
  <div class="group-input col-12 row q-mt-sm">
    <label for="type-os">Tipo de OS</label>
    <q-select
      id="type-os"
      class="col-12 q-mt-sm form-tabulacao"
      outlined
      dense
      ref="typeOSRef"
      v-model="requestData.typeOS"
      color="red-9"
      @filter="filterTypeOS"
      use-input
      hide-selected
      fill-input
      input-debounce="0"
      :options="optionsItens.optionsTypeOS"
      option-value="value"
      option-label="text"
      bg-color="white"
      :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
      lazy-rules
      @update:model-value="$emit('onTypeOsChange', requestData.typeOS)"
    />
  </div>
  <!-- <div class="group-input col-12 row q-mt-sm">
    <label>Status da OS</label>
    <div class="col-12 row flex justify-around q-mt-sm">
      <q-btn-toggle
          v-model="requestData.statusOS"
          spread
          class="col-12"
          no-caps
          rounded
          toggle-color="red-6"
          color="gray-8"
          text-color="white"
          :options="[
          { label: 'Executada', value: 1 },
          { label: 'Não Executada', value: 0 },
        ]"
      />
    </div>
  </div> -->
  <div class="group-input col-12 row q-mt-lg">
    <label for="write-off-code">Código de Baixa</label>
    <q-select
      id="write-off-code"
      class="col-12 q-mt-sm"
      outlined
      dense
      ref="writeOffCodeRef"
      v-model="requestData.writeOffCode"
      color="red-9"
      @filter="filterWriteOffCode"
      use-input
      hide-selected
      fill-input
      input-debounce="0"
      :options="optionsItens.optionsWriteOffCode"
      option-value="value"
      option-label="text"
      bg-color="white"
      :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
      lazy-rules
    />
    <DialogCardsOsAvailableReplicate
      :listOsRequest="
        contract.osRequests.filter((element) => {
          return element.osNumber != requestData.osNumber;
        })
      "
      :show="modalReplicateWriteOffCode"
      @replicateWriteOffCode="replicateWriteOffCode"
      @cancelReplicate="cancelReplicate"
    >
    </DialogCardsOsAvailableReplicate>
  </div>
  <div class="group-input col-12 row q-mt-md">
    <label for="observation">Observação</label>
    <div class="col-12 row flex justify-around">
      <q-input
        v-model="requestData.observation"
        class="col-12 q-mt-sm"
        bg-color="white"
        color="red-9"
        maxlength="300"
        outlined
        autogrow
      />
    </div>
  </div>
  <q-footer>
    <q-toolbar style="background: #e5e5e5">
      <div class="col-12 flex row">
        <div class="col-6 btn justify-center flex items-center">
          <q-btn
            unelevated
            rounded
            text-color="grey-8"
            @click="$emit('clearSchemaRequest')"
            label="Cancelar"
          />
        </div>
        <div class="col-6 btn justify-center flex items-center">
          <q-btn
            unelevated
            rounded
            color="red-9"
            label="Salvar"
            @click="
              validateSchemaRequest()
                ? $emit('saveSchemaRequest', returnSchemaRequest())
                : ''
            "
          />
        </div>
      </div>
    </q-toolbar>
  </q-footer>
</template>

<script>
import { useQuasar } from "quasar";
import { ref, reactive, onMounted } from "vue";
import DialogCardsOsAvailableReplicate from "@/components/DialogCardsOsAvailableReplicate";
import SelectCheckbox from "@/components/SelectCheckbox";
import DateTimePicker from "@/components/DateTimePicker";
import moment from "moment";

export default {
  name: "FormOsProductionRquest",
  components: {
    DialogCardsOsAvailableReplicate,
    SelectCheckbox,
    DateTimePicker,
  },
  props: {
    listWriteOffCode: Array,
    listTypeOS: Array,
    optionsWriteOffCode: Array,
    optionsTypeOS: Array,
    itemOsContract: Object,
  },

  setup(props) {
    moment.locale("pt-br");

    const $q = useQuasar();

    let requestData = reactive({
      object_id: "",
      osNumber: "",
      typeOS: "",
      statusOS: 1,
      writeOffCode: "",
      observation: "",
      check: false,
      replicate: false,
      source: "",
    });
    let contract = reactive({
      osRequests: [],
    });
    let confirmationReplicateWriteOffCode = ref(false);
    let modalReplicateWriteOffCode = ref(false);

    let schemaRequest = reactive({
      object_id: "",
      osNumber: "",
      typeOS: "",
      statusOS: 1,
      writeOffCode: "",
      observation: "",
      check: false,
      replicate: false,
      source: "",
    });

    const listTypeOS = ref([]);
    const listWriteOffCode = ref([]);
    const optionsItens = reactive({
      optionsTypeOS: props.listTypeOS,
      optionsWriteOffCode: props.listWriteOffCode,
    });

    function filterTypeOS(val, update) {
      update(() => {
        const needle = val.toLowerCase();
        optionsItens.optionsTypeOS = props.listTypeOS.filter(
          (v) => v.text.toLowerCase().indexOf(needle) > -1
        );
      });
    }

    function filterWriteOffCode(val, update) {
      update(() => {
        const needle = val.toLowerCase();
        optionsItens.optionsWriteOffCode = props.listWriteOffCode.filter(
          (v) => v.text.toLowerCase().indexOf(needle) > -1
        );
      });
    }

    function modalDialogConfirmarDeleteSchemaOsRequest() {
      $q.dialog({
        title: `Deletar OS ${props.itemOsContract.osNumber}`,
        message: `Atenção! Após deletar a OS, não há uma forma de reverter. Tem certeza que deseja deletar a OS selecionada?`,
        cancel: true,
        persistent: true,
        position: "bottom",
      })
        .onOk(() => {
          deleteSchemaRequest(props.itemOsContract.object_id);
        })
        .onCancel(() => {});
    }

    function openConfirmationReplicateWriteOffCode() {
      if (requestData.writeOffCode == "") {
        confirmationReplicateWriteOffCode.value = false;
        $q.notify({
          message: "Selecione pelo menos um código baixa antes de replicar.",
          color: "red-9",
          position: "top",
        });
        return;
      }

      if (confirmationReplicateWriteOffCode.value == true) {
        modalReplicateWriteOffCode.value = true;
      } else {
        cancelReplicate();
      }
    }

    function replicateWriteOffCode() {
      for (let item of contract.osRequests) {
        if (item.osNumber !== requestData.osNumber && item.replicate === true) {
          item.writeOffCode = requestData.writeOffCode;
        }
      }
      confirmationReplicateWriteOffCode.value = true;
      modalReplicateWriteOffCode.value = false;
    }

    function cancelReplicate() {
      confirmationReplicateWriteOffCode.value = false;
      for (let item of contract.osRequests) {
        item.replicate = false;
      }
    }

    function returnSchemaRequest() {
      let schemaRequest = {
        object_id: requestData.object_id,
        osNumber: requestData.osNumber,
        typeOS: requestData.typeOS,
        statusOS: requestData.statusOS,
        writeOffCode: requestData.writeOffCode,
        observation: requestData.observation,
        check: true,
        replicate: requestData.replicate,
        source: requestData.source,
      };

      return schemaRequest;
    }

    function validateSchemaRequest() {
      if (
        requestData.osNumber == "" ||
        requestData.writeOffCode == "" ||
        requestData.typeOS == "" ||
        requestData.observation == ""
      ) {
        $q.notify({
          message: "Todos os campos são obrigatórios.",
          color: "red-9",
          position: "top",
          timeout: 3000,
        });
        return false;
      }
      return true;
    }

    function _createOsRequestData() {
      requestData.osNumber = props.itemOsContract.data.osNumber;
      requestData.object_id = props.itemOsContract.data.object_id;
      requestData.typeOS = props.itemOsContract.data.typeOS;
      requestData.writeOffCode = props.itemOsContract.data.writeOffCode;
      requestData.statusOS = 1;
      requestData.observation = props.itemOsContract.data.observation;
      requestData.check = false;
      requestData.replicate = false;
      requestData.source = "NetSMS";
    }

    onMounted(() => {
      _createOsRequestData();
    });

    return {
      schemaRequest,
      requestData,
      optionsItens,
      confirmationReplicateWriteOffCode,
      modalReplicateWriteOffCode,
      openConfirmationReplicateWriteOffCode,
      replicateWriteOffCode,
      cancelReplicate,
      contract,
      returnSchemaRequest,
      validateSchemaRequest,
      filterWriteOffCode,
      filterTypeOS,
      modalDialogConfirmarDeleteSchemaOsRequest,
    };
  },
  emits: ["saveSchemaRequest", "clearSchemaRequest", 'onTypeOsChange'],
};
</script>

<style scoped></style>
